import { TERRA_API_HOST } from "../api-hosts";
import { httpClient } from "./http-client";
export default class FeatureTypeGroupService {
    getAll(req) {
        return httpClient({
            url: `feature-type-groups/${req.query ? `?${req.query}` : ""}`,
            baseURL: TERRA_API_HOST,
            headers: req.headers,
        })
    }
    async get(req) {
        return httpClient({
            url: `feature-type-groups/${req.uid}/${req.query ? `?${req.query}` : ""}`,
            baseURL: TERRA_API_HOST,
            headers: req.headers,
        })
    }
    async delete(req) {
        return httpClient({
            url: `feature-type-groups/${req.uid}/${req.query ? `?${req.query}` : ""}`,
            baseURL: TERRA_API_HOST,
            method: 'delete',
            headers: req.headers,
        })
    }
    async put(req) {
        return httpClient({
            url: `feature-type-groups/${req.uid}/${req.query ? `?${req.query}` : ""}`,
            baseURL: TERRA_API_HOST,
            method: 'put',
            data: req.body,
            headers: req.headers,
        })
    }
    async patch(req) {
        return httpClient({
            url: `feature-type-groups/${req.uid}/${req.query ? `?${req.query}` : ""}`,
            baseURL: TERRA_API_HOST,
            method: 'patch',
            data: req.body,
            headers: req.headers,
        })
    }
    async post(req) {
        return httpClient({
            url: `feature-type-groups/${req.query ? `?${req.query}` : ""}`,
            baseURL: TERRA_API_HOST,
            method: 'post',
            data: req.body,
            headers: req.headers,
        })
    }
    async assign_to_container(req) {
        return httpClient({
            url: `container-views/${req.id}/ftg/add/${req.query ? `?${req.query}` : ""}`,
            baseURL: TERRA_API_HOST,
            method: 'post',
            data: req.body,
            headers: req.headers,
        })
    }
    async unassign_from_container(req) {
        return httpClient({
            url: `container-views/${req.id}/ftg/remove/${req.query ? `?${req.query}` : ""}`,
            baseURL: TERRA_API_HOST,
            method: 'post',
            data: req.body,
            headers: req.headers,
        })
    }
    async assign_to_view(req) {
        return httpClient({
            url: `container-views/${req.id}/ftg/add/${req.query ? `?${req.query}` : ""}`,
            baseURL: TERRA_API_HOST,
            method: 'post',
            data: req.body,
            headers: req.headers,
        })
    }
    async unassign_from_view(req) {
        return httpClient({
            url: `container-views/${req.id}/ftg/remove/${req.query ? `?${req.query}` : ""}`,
            baseURL: TERRA_API_HOST,
            method: 'post',
            data: req.body,
            headers: req.headers,
        })
    }

    async get_ftg(req = {}) {
        return httpClient({
            url: `container-views/${req.id}/ftg/${req.query ? `?${req.query}` : ""}`,
            baseURL: TERRA_API_HOST,
            headers: req.headers,
        })
    }
}
